class Metrics {
    constructor() {
        this.reset();
    }
    addGeocoding() {
        this.geocoding++;
    }
    addtileLoad() {
        this.tiles++;
    }
    addClick() {
        this.clicks++;
    }
    addSelect() {
        this.selected++;
    }
    reset() {
        this.tiles = 0;
        this.geocoding = 0;
        this.selected = 0;
        this.clicks = 0;
        this.startTime = new Date();
    }
    stop() {
        this.endTime = new Date();
    }
    getResult() {
        return JSON.stringify({
            tiles: this.tiles,
            clicks: this.clicks,
            geocoding: this.geocoding,
            selected: this.selected,
            start: this.startTime.toLocaleTimeString(),
            end: this.endTime.toLocaleTimeString(),
        }, null, 2);
    }
}
export const metrics = new Metrics();
